export const useSeo = (seoInput) => {
  const i18nHead = useLocaleHead()
  const setI18nParams = useSetI18nParams()
  const runtimeConfig = useRuntimeConfig()
  const route = useRoute()

  const seo = isRef(seoInput) ? seoInput : ref(seoInput)

  if (seo.value?.localeParams) {
    setI18nParams(seo.value.localeParams)
  }

  const meta = seo.value?.meta || []
  const link = seo.value?.link || []

  const title = `${seo.value?.title} | ${runtimeConfig.public.siteName}` || ''

  return useHead({
    title,
    meta: [
      ...i18nHead.value.meta,

      ...meta.map((meta) => {
        if (meta.name === 'description') {
          const description = `${meta.content} | ${runtimeConfig.public.siteName}`

          return [
            {
              ...meta,
              content: description,
            },
            {
              property: 'og:description',
              content: description,
            },
          ]
        } else {
          return meta
        }
      }),
      {
        property: 'og:title',
        content: title,
      },
      {
        property: 'og:url',
        content: `${runtimeConfig.public.baseURL}${route.fullPath}`,
      },
      {
        property: 'og:image',
        content: `${runtimeConfig.public.baseURL}assets/img/og-image-bioenologia.jpg`,
      },
    ].flat(),
    bodyAttrs: { ...i18nHead.value.htmlAttrs },
    link: [...i18nHead.value.link, ...link],
  })
}
